"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ResultDialog = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const props = (0, _contexts.useResultDialog)();
  const {
    content,
    onClose
  } = props;
  const actions = (0, _react.useMemo)(() => [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    "data-testid": getTestId(_constants.RESULT_DIALOG_CLOSE_BUTTON),
    color: "primary",
    variant: "contained",
    maxWidth: "330px",
    onClick: onClose,
    children: translations.gotIt
  }, "no")], [getTestId, onClose, translations.gotIt]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
    ...props,
    "data-testid": getTestId(_constants.RESULT_DIALOG),
    actions: actions,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      textAlign: "left",
      children: content
    })
  });
};
exports.ResultDialog = ResultDialog;
